import { debounce } from "../utils";
import { IMessagingService } from "../services";
import { Component } from "./component";

class CardStatsComponent extends Component {
    private statsItems: HTMLElement[];
    private handleResize: () => void;
    
    constructor(componentEl: HTMLElement, messagingService: IMessagingService) {
        super(componentEl, messagingService);

        this.statsItems = [...componentEl.querySelectorAll(".card-component")] as HTMLElement[];

        this.handleResize = debounce(() => {
            this.calculateStatsSecondRow();
        }, 100);

        window.addEventListener('resize', this.handleResize);

        this.calculateStatsSecondRow();
    }

    private calculateStatsSecondRow() {
        this.statsItems.forEach((element) => {
            element.classList.remove('last-card-in-first-row');
        });
        
        const firstStatBounds = this.statsItems[0].getBoundingClientRect();
    
        const firstStatInSecondRowIndex = this.statsItems.findIndex((element) => {
            const nextStat = element.getBoundingClientRect();
            return nextStat.top > firstStatBounds.bottom;
        });
    
        if (firstStatInSecondRowIndex !== -1) {
            this.statsItems[firstStatInSecondRowIndex -1].classList.add('last-card-in-first-row');
        }
    }
}

export { CardStatsComponent };
